/**
 * Get categories based on shop name
 * MCP shops have different categories than regular shops
 */
export const getCategoriesForShop = (shopName) => {
  if (shopName && shopName.includes('MCP')) {
    // MCP shops: Chain, Sprocket, Brake, Clutch, Filter, Battery, Spark Plug, Other
    return ['Chain', 'Sprocket', 'Brake', 'Clutch', 'Filter', 'Battery', 'Spark Plug', 'Other'];
  } else {
    // Regular shops: Tire, Oil, Rim, Other
    return ['Tire', 'Oil', 'Rim', 'Other'];
  }
};

/**
 * Get default category for a shop
 */
export const getDefaultCategoryForShop = (shopName) => {
  if (shopName && shopName.includes('MCP')) {
    return 'Chain';
  } else {
    return 'Tire';
  }
};

